import React from "react"

import { WithChildren } from "shared/types/WithChildren"

import {
  ProductPageContext,
  ProductPageContextType
} from "../context/ProductPageContext"
import { ProductPageAddonTitlesProvider } from "./ProductPageAddonTitlesProvider"
import { ProductPageImportProvider } from "./ProductPageImportProvider"

interface ProductPageRootProps extends ProductPageContextType, WithChildren {}

export const ProductPageRoot = React.memo(
  React.forwardRef<HTMLDivElement, ProductPageRootProps>(
    ({ children, ...rest }, ref) => {
      return (
        <ProductPageContext.Provider value={rest}>
          <ProductPageAddonTitlesProvider>
            <ProductPageImportProvider>
              <div
                ref={ref}
                className="product-page"
                data-testid="product-page"
                // When arriving at a productpage with a configuration different from the default
                // the images/texts are different from the prerendered content
                // We still prerender for SEO purposes but allow the hydration mismatch here.
                // The alternative would be to to delay everthing that is configuration dependent
                // by at least 1 render cycle.
                suppressHydrationWarning
              >
                {children}
              </div>
            </ProductPageImportProvider>
          </ProductPageAddonTitlesProvider>
        </ProductPageContext.Provider>
      )
    }
  )
)
